import { useState } from "react";
import {
  detectAddressColumn,
  detectPostcodeColumn,
  detectUprnColumn,
} from "../lib/columnDetect";
import type { ProcessingMode } from "../lib/cleanseSchema";

export function useColumnMapping() {
  const [line1Col, setLine1Col] = useState("");
  const [postcodeCol, setPostcodeCol] = useState("");
  const [uprnCol, setUprnCol] = useState("");

  // Pre-fill the column selects based on mode-specific name heuristics. Empty
  // result for a slot means "no auto-detect match"; the user can still pick
  // manually.
  function autoDetect(headers: string[], mode: ProcessingMode) {
    if (mode === "cleanse") {
      setLine1Col(detectAddressColumn(headers));
      setPostcodeCol(detectPostcodeColumn(headers));
      setUprnCol("");
    } else {
      setUprnCol(detectUprnColumn(headers));
      setLine1Col("");
      setPostcodeCol("");
    }
  }

  function reset() {
    setLine1Col("");
    setPostcodeCol("");
    setUprnCol("");
  }

  return {
    line1Col,
    postcodeCol,
    uprnCol,
    setLine1Col,
    setPostcodeCol,
    setUprnCol,
    autoDetect,
    reset,
  };
}
